import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  CountBox,
  Count,
  Details,
  Name,
  FeetInches,
} from './styled';

export default class SegmentItem extends PureComponent {
  static propTypes = {
    count: PropTypes.number.isRequired,
    edges: PropTypes.array.isRequired,
    feetInches: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    outlineSegments: PropTypes.func.isRequired,
  };

  render() {
    const { count, edges, feetInches, name, outlineSegments } = this.props;

    return (
      <Container onClick={() => outlineSegments(edges)}>
        <CountBox>
          <Count>{count}</Count>
        </CountBox>
        <Details>
          <Name>{name}</Name>
          <FeetInches>{feetInches}</FeetInches>
        </Details>
      </Container>
    );
  }
}
